import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import Player from '@vimeo/player';
import { AuthService } from '../../services/auth-service';
import { Api } from '../../services/api';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { Login } from '../login/login';
import { Shared } from '../../services/shared';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CommentsModal,
  PersonReview
} from '../../comments-modal/comments-modal';



@Component({
  selector: 'app-course-main',
  standalone: false,
  templateUrl: './course-main.html',
  styleUrl: './course-main.scss'
})
export class CourseMain implements OnInit {
  @ViewChild('authModal') authModal!: Login;
  @ViewChild('videoIframe', { static: false }) videoIframe!: ElementRef;
  @ViewChild('html5Video') html5Video!: ElementRef<HTMLVideoElement>;
  isLoggedIn: boolean = false;
  currentLecture: any = null;
  todaylivelatestsession: any = ''
  todaylivelatestsessionDate: any = ''
  rating: number = 0;
  attendedId: any;
  livesessionname: { lecturename: string; lectureID: string, moduleName: string, bookingId: any, sessionId: any, editflag: any } = {
    lecturename: '',
    lectureID: '',
    moduleName: '',
    bookingId: '',
    sessionId: '',
    editflag: '',
  };
  slotDate: any = ""
  todaySession: any;
  todayDisplay: any;
  conmpltedCoursePer: any = "";
  joinLink: any = ""
  TodayJoinLink: any[] = []
  triggeredQuizPoints = new Set<number>();
  chapters: any[] = [];
  liveSessions: any[] = [];
  videoMap: { [key: string]: string } = {
    'phonicsIntro1': '357274789',
    'phonicsIntro2': '76979871'
  };
  expandedSections: boolean[] = [false, false, false, false, false];
  showVideoModal = false;
  showVideoModalforSlot = false
  currentVideo: string | null = null;
  allExpanded = false;
  closeVideoforslot: boolean = false;
  player: any;
  quizIndex = 0;
  correctAnswerCount = 0;
  showQuizModal = false;
  currentQuestion: any = null;
  userAnswer: string = '';
  questions: any[] = [];
  courseData: any = {};
  userInfo: any = {};
  isFullscreen = false;
  missingSession: string = "";
  user: any;
  isexpiredforlive: any;

  toggleChapter(index: number) {
    this.chapters[index].open = !this.chapters[index].open;
  }

  constructor(private modalService: NgbModal, private activatedRoute: ActivatedRoute, private location: Location,
    public authService: AuthService, private apiservices: Api, private router: Router, private sharedService: Shared) {
    this.authService.isLoggedIn$.subscribe(status => {
      this.isLoggedIn = status;
    });
    this.userInfo = authService.getUser();
  }


  ngOnInit(): void {
    const userString = this.authService.getUser();
    //  this.sharedService.closeFeedback$.subscribe(flag => {

    //   console.log('Received:', flag);

    //   if (flag) {
    //     this.feedbackModal = false;

    //     // Reset for next time
    //     this.sharedService.closeFeedback(false);
    //   }

    // });
    if (userString) {
      this.user = typeof userString === 'string'
        ? JSON.parse(userString)
        : userString;


    }

    this.activatedRoute.queryParams.subscribe(params => {

      if (params && params['courseName']) {
        this.apiservices.getCourseDetails({ trainingCourseName: params['courseName'], userId: this.user.userId, schoolId: this.user.schoolId }).subscribe((result: any) => {
          this.courseData = result?.data || {};
          console.log("this.courseData", this.courseData)
          this.getTodayLatestLectureLink(this.courseData)
          this.conmpltedCoursePer = this.courseData?.completionPercentage
            ? Math.floor(this.courseData.completionPercentage) + '%'
            : '0%';
          this.buildChapters();

        })

      }
      else {
        this.location.back()
      }
    })
    this.apiservices.bookingSuccess$.subscribe((res: boolean) => {
      console.log('Booking success:', res);

      if (res) {
        // do your action here
        this.closeVideoforSlot();
        this.activatedRoute.queryParams.subscribe(params => {

          if (params && params['courseName']) {
            this.apiservices.getCourseDetails({ trainingCourseName: params['courseName'], userId: this.user.userId, schoolId: this.user.schoolId }).subscribe((result: any) => {
              this.courseData = result?.data || {};
              console.log("this.courseData", this.courseData)
              this.getTodayLatestLectureLink(this.courseData)
              this.conmpltedCoursePer = this.courseData?.completionPercentage
                ? Math.floor(this.courseData.completionPercentage) + '%'
                : '0%';
              this.buildChapters();

            })

          }
          else {
            this.location.back()
          }
        })
      }
    });

  }

  private buildChapters(): void {
    this.chapters = this.courseData?.modules?.map((module: any) => ({
      moduleName: module.moduleName,
      duration: module.duration,
      open: false,
      videos: module.lectures.map((lecture: any) => ({
        lectureName: lecture.lectureName,
        url: lecture.meetingLink,
        time: this.formatDuration(lecture.durationInSeconds), // convert number → string
        lectureRef: lecture,
        lectureType: lecture.lectureType,
        lectureId: lecture.lectureId,
        bookedslotDate: lecture.bookedSlotDate,
        bookedslotime: lecture.bookedSlotTime,
        bookingid: lecture.bookingId,
        isbooked: lecture.isBooked,
        sessionid: lecture.sessionId,
        Completed: lecture.completed,
        isdisabled: lecture.isDisabled,
        isExpired: lecture.isExpired,
        isRescheduled: lecture.isRescheduled,
        hasUpcommingSlot: lecture.hasUpcommingSlot,
        rating: lecture.rating
      }))
    }));
  }

  // ----------------- Section toggle -----------------
  toggleSection(index: number): void {
    this.expandedSections[index] = !this.expandedSections[index];
  }

  expandAll(): void {
    this.allExpanded = !this.allExpanded;
    this.expandedSections = this.expandedSections.map(() => this.allExpanded);
  }

  // ----------------- Video Player -----------------
  playVideo(videoUrl: string, lecture?: any): void {
    this.apiservices.getQuestions({ lectureId: lecture?.lectureId }).subscribe((result: any) => {
      this.questions = result.data;
      this.currentLecture = lecture;
      this.currentVideo = videoUrl;
      this.showVideoModal = true;
      this.quizIndex = 0;
      this.triggeredQuizPoints.clear();

      setTimeout(() => {

        // Cleanup previous player
        if (this.player) {
          this.player.destroy();
          this.player = null;
        }

        // if (this.isVimeo(videoUrl)) {
        //   const videoId = this.extractVimeoId(videoUrl);

        //   this.player = new Player(this.videoIframe.nativeElement, {
        //     id: videoId,
        //     autoplay: true,
        //     responsive: true
        //   });

        //   this.player.on('loaded', async () => {
        //     if (this.currentLecture?.lastWatched > 0) {
        //       await this.player.setCurrentTime(this.currentLecture.lastWatched);
        //     }
        //     this.setupQuizWatcher();
        //   });
        //   this.player.on('timeupdate', (data: any) => {
        //     if (this.currentLecture) {
        //       this.currentLecture.lastWatched = Math.floor(data.seconds);
        //     }
        //   });
        //   this.player.on('ended', () => {
        //     if (this.currentLecture) {
        //       this.currentLecture.completed = true;
        //     }
        //   });


        // }
        if (this.isVimeo(videoUrl)) {

          const videoId = this.extractVimeoId(videoUrl);

          this.player = new Player(this.videoIframe.nativeElement, {
            id: videoId,
            autoplay: true,
            responsive: true
          });

          this.player.on('loaded', async () => {

            // lastWatched restore removed

            this.setupQuizWatcher();

          });

          this.player.on('timeupdate', (data: any) => {

            if (this.currentLecture) {

              // keep tracking progress (DO NOT REMOVE)
              this.currentLecture.lastWatched = Math.floor(data.seconds);

            }

          });

          this.player.on('ended', () => {

            if (this.currentLecture) {

              this.currentLecture.completed = true;

            }

          });

        }
        else if (this.isYouTube(videoUrl)) {
          const videoId = this.extractYouTubeId(videoUrl);

          this.videoIframe.nativeElement.src = '';
          setTimeout(() => {
            this.videoIframe.nativeElement.src =
              `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`;
          }, 50);
        }
        else {
          if (this.html5Video?.nativeElement) {
            const videoEl = this.html5Video.nativeElement;

            videoEl.src = videoUrl;
            videoEl.currentTime = this.currentLecture?.lastWatched || 0;
            videoEl.play();

            this.setupHtml5QuizWatcher(videoEl);
          }
        }


      }, 300);
    })
  }


  isVimeo(url: string | null): boolean {
    return !!url && /vimeo\.com/.test(url);
  }

  isYouTube(url: string | null): boolean {
    return !!url && /youtube\.com|youtu\.be/.test(url);
  }


  extractVimeoId(url: string): number {
    const match = url.match(/vimeo\.com\/(\d+)/);
    return match ? Number(match[1]) : 0;
  }


  extractYouTubeId(url: string): string {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[2].length === 11 ? match[2] : '';
  }

  closeVideo(): void {
    this.showVideoModal = false;
    this.currentVideo = null;
    this.isFullscreen = false;

    if (this.player) {
      this.player.destroy();
      this.player = null;
    }

    if (this.videoIframe?.nativeElement) {
      this.videoIframe.nativeElement.src = '';
    }

    if (this.html5Video?.nativeElement) {
      this.html5Video.nativeElement.pause();
      this.html5Video.nativeElement.src = '';
    }
  }

  setupQuizWatcher() {
    if (!this.player || !this.currentLecture) return;

    const quizPoints = JSON.parse(this.currentLecture.quizPoints) || [];

    this.player.on('timeupdate', (data: any) => {
      const sec = Math.floor(data.seconds);

      for (let i = 0; i < quizPoints.length; i++) {
        const quizTime = quizPoints[i];

        // trigger only once
        if (
          sec >= quizTime &&
          !this.triggeredQuizPoints.has(quizTime)
        ) {
          this.triggeredQuizPoints.add(quizTime);

          this.player.pause();
          this.currentQuestion = this.questions[i]; // sync question
          this.showQuizModal = true;
          return;
        }
      }
    });
  }
  setupHtml5QuizWatcher(videoEl: HTMLVideoElement) {
    if (!this.currentLecture) return;

    const quizPoints = JSON.parse(this.currentLecture.quizPoints) || [];

    videoEl.ontimeupdate = () => {
      const sec = Math.floor(videoEl.currentTime);

      // Save progress
      this.currentLecture.lastWatched = sec;

      for (let i = 0; i < quizPoints.length; i++) {
        const quizTime = quizPoints[i];

        if (
          sec >= quizTime &&
          !this.triggeredQuizPoints.has(quizTime)
        ) {
          this.triggeredQuizPoints.add(quizTime);

          videoEl.pause();
          this.currentQuestion = this.questions[i];
          this.showQuizModal = true;
          return;
        }
      }
    };

    videoEl.onended = () => {
      this.currentLecture.completed = true;
    };
  }



  submitAnswer(answer: string) {
    const correct =
      answer.toLowerCase().trim() === this.currentQuestion.answer.toLowerCase().trim();
    // if (correct) {
    //   this.quizIndex++;
    //   this.showQuizModal = false;

    //   if (this.isVimeo(this.currentVideo)) {
    //     this.player.play();
    //   } else {
    //     this.html5Video.nativeElement.play(); //  HTML5 resume
    //   }
    // }
    // else {
    //   this.confirmData = {
    //     title: '❌ Wrong!',
    //     message: 'Do you want to rewatch this part?',
    //     callback: (confirmed: boolean) => {
    //       if (confirmed) {
    //         this.player.setCurrentTime(this.currentQuestion.time - 10);
    //         this.showQuizModal = false;
    //       } else {

    //         this.showQuizModal = false;
    //         this.quizIndex++;
    //         this.player.play();
    //       }
    //     }
    //   };
    //   this.showConfirmModal = true;
    // }
    if (correct) {
      this.correctAnswerCount++;
    }
    this.apiservices.saveAnswer({
      userId: this.userInfo?.userId,
      videoQuestionId: this.currentQuestion.videoQuestionId,
      answer: answer
    }).subscribe(() => {
      this.quizIndex++;
      this.showQuizModal = false;

      if (this.isVimeo(this.currentVideo)) {
        this.player.play();
      } else {
        this.html5Video.nativeElement.play(); //  HTML5 resume
      }
      this.userAnswer = ''; // reset for next
      if (this.questions.length === this.quizIndex) {
        this.confirmData = {
          title: 'Submitted All the answers',
          message: `your score is ${this.correctAnswerCount}/${this.quizIndex}`,
          callback: (confirmed: boolean) => {
            if (confirmed) {
              this.showQuizModal = false;
            } else {
              this.showQuizModal = false;
            }
          }
        };
        this.showConfirmModal = true;
      }
    })

  }


  showConfirmModal = false;
  confirmData: { title: string; message: string; callback: (confirmed: boolean) => void } = {
    title: '',
    message: '',
    callback: () => { }
  };

  onConfirm() {
    this.showConfirmModal = false;
    this.confirmData.callback(true);
  }

  onCancel() {
    this.showConfirmModal = false;
    this.confirmData.callback(false);
  }
  JoiSession(link: any, date: any, time: any, completionId: any) {
    console.log("date", date)
    const now = new Date();
    console.log("now", now)
    const today = now.toISOString().split('T')[0];
    console.log("today", today)
    // remove AM/PM
    const cleanTime = time.replace(/(AM|PM)/i, '').trim();

    const slotDateTime = new Date(`${date}T${cleanTime}`);

    // 5 minutes before session
    const joinStartTime = new Date(slotDateTime.getTime() - 15 * 60 * 1000);
    console.log("joinstarttime", joinStartTime)
    // 10 minutes after session
    const joinEndTime = new Date(slotDateTime.getTime() + 55 * 60 * 1000);

    if (date !== today) {
      this.apiservices.displayToast(`Please join  ${time}`, 500);
      return;
    }

    if (now < joinStartTime) {
      this.apiservices.displayToast(
        `You can join only 15 minutes before ${time}`,
        500
      );
      return;
    }

    if (now > joinEndTime) {
      this.apiservices.displayToast(`Session join time expired`, 500);
      return;
    }

    // allowed
    window.open(link, '_blank');
    if (completionId) {
      this.apiservices.updateRecord(completionId).subscribe(res => {
        console.log(res)
      })
    }
  }
  formatDateDDMMYYYY(dateString: string): string {

    const d = new Date(dateString);

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;

  }
  showJoinButton: boolean = false;
  showTodayLectureButton = false;
  canJoinMeeting = false;
  getTodayLatestLectureLink(courseData: any) {

    const today = new Date().toISOString().split('T')[0];
    const now = new Date();

    let todayLectures: any[] = [];

    courseData?.modules?.forEach((module: any) => {

      module?.lectures?.forEach((lecture: any) => {

        if (lecture?.isBooked && lecture?.bookedSlotDate === today) {

          const slotDateTime = this.parseSlotDateTime(
            lecture.bookedSlotDate,
            lecture.bookedSlotTime
          );

          if (!slotDateTime) return;

          const joinStartTime = new Date(slotDateTime.getTime() - 15 * 60 * 1000);
          const joinEndTime = new Date(slotDateTime.getTime() + 55 * 60 * 1000);

          todayLectures.push({
            ...lecture,
            slotDateTime,
            joinStartTime,
            joinEndTime
          });

        }

      });

    });

    // ❌ No lectures
    if (!todayLectures.length) {
      this.showJoinButton = false;
      this.canJoinMeeting = false;
      return;
    }

    // ✅ Sort by time (ascending)
    todayLectures.sort((a: any, b: any) => a.slotDateTime - b.slotDateTime);

    // 🔥 KEY FIX: Skip expired lectures
    const validLecture = todayLectures.find(
      (lec: any) => lec.isExpired === false
    );

    // ❌ No valid lecture found
    if (!validLecture) {
      this.showJoinButton = false;
      this.canJoinMeeting = false;
      return;
    }

    // ✅ Show button
    this.showJoinButton = true;

    // ✅ Enable based on time window (optional)
    this.canJoinMeeting =
      now >= validLecture.joinStartTime && now <= validLecture.joinEndTime;

    // 🎯 Assign data
    this.todaylivelatestsession = validLecture.meetingLink;
    this.attendedId = validLecture.bookingId;

    this.todayDisplay = this.formatSlotDate(
      validLecture.bookedSlotDate,
      validLecture.bookedSlotTime
    );
  }
  parseSlotDateTime(date: string, time: string): Date | null {
    if (!date || !time) return null;

    let hours: number;
    let minutes: number;

    const upperTime = time.toUpperCase();

    const isPM = upperTime.includes('PM');
    const isAM = upperTime.includes('AM');

    // Remove AM/PM
    const cleanTime = upperTime.replace(/(AM|PM)/i, '').trim();

    const [h, m] = cleanTime.split(':');

    if (!h || !m) return null;

    hours = parseInt(h, 10);
    minutes = parseInt(m, 10);

    if (isNaN(hours) || isNaN(minutes)) return null;

    // Convert to 24-hour format
    if (isPM && hours < 12) hours += 12;
    if (isAM && hours === 12) hours = 0;

    const finalDate = new Date(date);
    finalDate.setHours(hours, minutes, 0, 0);

    return finalDate;
  }
  joinMeeting(Link: any, attendedId: any) {
    console.log("attendedId", attendedId)

    if (!this.isLoggedIn) {
      this.openLoginModal();
      return;
    }

    if (!this.canJoinMeeting) {
      alert("Lecture joining will activate at the scheduled time.");
      return;
    }

    if (Link) {
      window.open(Link, '_blank');
    }
    if (attendedId) {
      this.apiservices.updateRecord(attendedId).subscribe(res => {
        console.log(res)
      })
    }

  }
  deleteModal: boolean = false;
  feedbackModal: boolean = false;
  Bookingid: any;
  confirmOpen: boolean = false;
  attendedAlert: boolean = false;
  slotnotBooked: boolean = false;
  OpenLogin() {
    this.openLoginModal()
  }
  openLoginModal() {
    this.authModal.openModal('login');
  }
  onModalClosed() {
    console.log('Modal was closed');
  }
  openVideoforSlot(lecName: any, Id: string, modulename: string, bookingId: any, sessionId: any, editFlage: any) {
    this.showVideoModalforSlot = true;
    this.livesessionname.lecturename = lecName;
    this.livesessionname.lectureID = Id
    this.livesessionname.moduleName = modulename
    this.livesessionname.bookingId = bookingId
    this.livesessionname.sessionId = sessionId
    this.livesessionname.editflag = editFlage
    this.closeConfirmModal()
  }
  closeVideoforSlot() {
    this.showVideoModalforSlot = false;
    this.livesessionname.lecturename = "";
    this.livesessionname.lectureID = ""
    this.livesessionname.moduleName = ""
    this.livesessionname.bookingId = ""
    this.livesessionname.sessionId = ""
    this.livesessionname.editflag = ""
  }
  openDeleteSession(bookID: any) {
    this.deleteModal = true;
    this.Bookingid = bookID;
  }
  closeDeleteSession() {
    this.deleteModal = false;
    this.Bookingid = "";
  }
  toggleFullscreen() {
    this.isFullscreen = !this.isFullscreen;
  }
  feebackopen(sessionid: any, rating: any) {
    this.router.navigate(['/feedback'],
      {
        queryParams: {
          phoneNumber: this.user.phoneNumber,
          sessionId: sessionid,
          rating: rating,
          fromParent: true
        }
      });

  }
  feebackClose() {
    this.feedbackModal = false;
  }
  openConfirmModal(lecName: any, Id: string, modulename: string, bookingId: any, sessionId: any, editFlage: any) {

    this.livesessionname.lecturename = lecName;
    this.livesessionname.lectureID = Id
    this.livesessionname.moduleName = modulename
    this.livesessionname.bookingId = bookingId
    this.livesessionname.sessionId = sessionId
    this.livesessionname.editflag = editFlage
    this.confirmOpen = true
  }
  closeConfirmModal() {
    this.confirmOpen = false
  }
  selectSlotDate: any;
  selectedSlotTime: any;
  missesalert: boolean = false
  sessionId: any
  openattendedAlert(bookedSlotDate: any, bookedslotime: any, sessionId: any) {
    this.attendedAlert = true;
    this.selectSlotDate = bookedSlotDate.split('-').reverse().join('-');;
    this.selectedSlotTime = bookedslotime;
    this.sessionId = sessionId;

  }
  openmissedAlert(bookedSlotDate: any, bookedslotime: any, sessionId: any) {
    this.missesalert = true;
    this.selectSlotDate = bookedSlotDate.split('-').reverse().join('-');;
    this.selectedSlotTime = bookedslotime;
    this.sessionId = sessionId;
  }
  openNotbookedAlert() {
    this.slotnotBooked = true
  }
  closeattendedAlert() {
    this.attendedAlert = false;
    this.selectSlotDate = '';
    this.selectedSlotTime = '';
    // this.sessionId = '';
    this.feedbackopenwithsessionID()
  }
  closedmissedAlert() {
    this.missesalert = false;
    this.selectSlotDate = '';
    this.selectedSlotTime = '';
    this.sessionId = '';
  }

  feedbackopenwithsessionID() {
    this.feebackopen(this.sessionId, this.rating)
  }
  CloseNotbookedAlert() {
    this.slotnotBooked = false;
  }
  openHelpDesk() {
    const phoneNumber = '919871268882';
    const message = encodeURIComponent(
      'Hi, I need help regarding my missed training session.'
    );

    window.open(
      `https://wa.me/${phoneNumber}?text=${message}`,
      '_blank'
    );
  }
  formatDuration(seconds: number) {
    if (seconds === 0 || seconds === null) {
      return ''
    }
    if (seconds < 60) {
      return `${seconds} sec`;
    }
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);

    return h > 0 ? `${h}hr ${m}mins` : `${m}mins`;
  }
  sessionDate: Date = new Date('2026-02-20T19:00:00');
  navgate(sessionName: any) {
    this.router.navigate(['/BookLive-Session'], { queryParams: { sessionname: sessionName } })
      .then(success => console.log("Navigation success:", success))
      .catch(err => console.error("Navigation error:", err));
  }
  formatSlotDate(dateString: any, datetime: any): any {
    this.isTodaySessionDate(dateString, datetime);

    const time = datetime.replace(/(AM|PM)/i, '').trim();
    const date = new Date(`${dateString}T${time}`);

    if (isNaN(date.getTime())) return '';

    const formatted = date.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });

    const parts = formatted.split(' at ');

    const datePart = parts[0];
    const timePart = parts[1];

    return `${timePart}, ${datePart}`;
  }
  isPastDate(dateString: any, datetime: any): boolean {

    const cleanTime = datetime.replace(/(AM|PM)/i, '').trim();
    const slotDateTime = new Date(`${dateString}T${cleanTime}`);


    // add 20 minutes grace
    const pastCheckTime = new Date(slotDateTime.getTime() + 55 * 60 * 1000);


    const currentDateTime = new Date();

    return currentDateTime.getTime() > pastCheckTime.getTime();
  }
  isPastDateAttended(dateString: any, datetime: any, isBooked: any, completed: any, isExpired: any): boolean {
    return completed === 1 && isExpired === true;
    // const cleanTime = datetime.replace(/(AM|PM)/i, '').trim();
    // const slotDateTime = new Date(`${dateString}T${cleanTime}`);


    // add 20 minutes grace
    // const pastCheckTime = new Date(slotDateTime.getTime() + 10 * 60 * 1000);


    // const currentDateTime = new Date();

    // return currentDateTime.getTime() > pastCheckTime.getTime();
  }
  isPastDateAttendedMissed(dateString: any, datetime: any, isBooked: any, completed: any, isExpired: any): boolean {
    return completed === 0 && isBooked === true && isExpired === true;
    //  if (!isBooked) {
    //   return false;
    // }
    // if (isBooked && completed) {
    //   return false;
    // }
    // const cleanTime = datetime.replace(/(AM|PM)/i, '').trim();
    // const slotDateTime = new Date(`${dateString}T${cleanTime}`);


    // // add 20 minutes grace
    // const pastCheckTime = new Date(slotDateTime.getTime() + 10 * 60 * 1000);


    // const currentDateTime = new Date();

    // return currentDateTime.getTime() > pastCheckTime.getTime();


  }

  isTodaySessionDate(dateString: any, time: any): any {
    const cleanTime = time.replace(/(AM|PM)/i, '').trim();
    const slotDateTime = new Date(`${dateString}T${cleanTime}`);
    const today = new Date();

    const slotDay = slotDateTime.toDateString();
    const todayDay = today.toDateString();

    if (slotDay === todayDay) {

      this.todaySession = slotDateTime.toLocaleString('en-IN', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });

      return this.todaySession;

    } else {

      this.todaySession = "";
      return "";

    }
  }
  bookflag(flag: any): boolean {
    return !!flag;
  }
  onConfirmDelete() {
    this.apiservices.deleteBookedSession(this.Bookingid).subscribe({
      next: (response: any) => {
        this.apiservices.displayToast('Your booked slot has been deleted successfully.', 200);

        this.closeDeleteSession();

        // Refresh list if needed
        this.bookingApi();
      },
      error: (error) => {
        console.error('Error deleting booking:', error);
        this.apiservices.displayToast('Failed to delete the booked slot. Please try again.', 500);

      },
      complete: () => {
        this.apiservices.displayToast('Your booked slot has been deleted successfully.', 200);
      }
    });
  }

  bookingApi() {
    this.activatedRoute.queryParams.subscribe(params => {

      if (params && params['courseName']) {
        this.apiservices.getCourseDetails({ trainingCourseName: params['courseName'], userId: this.user.userId, schoolId: this.user.schoolId }).subscribe((result: any) => {
          this.courseData = result?.data || {};
          console.log("this.courseData", this.courseData)
          this.getTodayLatestLectureLink(this.courseData)
          this.conmpltedCoursePer = this.courseData?.completionPercentage
            ? Math.floor(this.courseData.completionPercentage) + '%'
            : '0%';
          this.buildChapters();

        })

      }
      else {
        this.location.back()
      }
    })
  }
  // Store rating separately for each lecture/session
  lectureRatings: { [sessionId: string]: number } = {};
  sessionID: any;

  selectLectureRating(sessionId: string, rating: number): void {
    this.rating = rating;
    // this.feebackopen(sessionId,this.rating)
    this.sessionID = sessionId
    this.lectureRatings[sessionId] = rating;
    console.log('Selected rating:', rating);
  }
  ratingSubmit(rating: any) {
    if (rating !== null) {
      this.apiservices.displayToast(
        'Thank you for trying again! You have already submitted your rating for this lecture.',
        200
      );
      return;
    }
    else {
      this.feebackopen(this.sessionID, this.rating)
    }

  }

  getDisplayedRating(video: any): number {
    if (video.rating !== null && video.rating !== undefined) {
      return Number(video.rating) || 0;
    }

    return this.lectureRatings[video.sessionid] || 0;
  }


  openReviews(lectureId: any): void {
    this.apiservices.getFeedbacksOfLecture({ lectureId }).subscribe((result: any) => {
      const modalRef = this.modalService.open(
        CommentsModal,
        {
          size: 'lg',
          centered: true,
          scrollable: true,
          backdrop: 'static'
        }
      );

      modalRef.componentInstance.reviews = result?.data;
    })
  }
}